import LegalPage from "./LegalPage";

export default function Terms() {
  return <LegalPage contentKey="terms" testId="terms-page" />;
}
